import { EntityDocumentsOrderBy } from '../../../../common/types/globalTypes';
import {
  OrderDirection,
  SortOrder,
  OrderLookup,
} from 'common/utils/commonTypes';
import { FilterArrayType, FilterCombineType } from 'common/components/Filters';

const orderByMap = new Map<string, OrderLookup>([
  [
    '_documentType',
    {
      [OrderDirection.ASC]: [
        'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DOCUMENT_TYPE_ASC',
      ],
      [OrderDirection.DESC]: [
        'DOCUMENT_TYPE_BY_DOCUMENT_TYPE_ID__DOCUMENT_TYPE_DESC',
      ],
    },
  ],
  [
    'indexName',
    {
      [OrderDirection.ASC]: ['INDEX_NAME_ASC'],
      [OrderDirection.DESC]: ['INDEX_NAME_DESC'],
    },
  ],
  [
    'indexReferenceNumber',
    {
      [OrderDirection.ASC]: ['INDEX_REFERENCE_NUMBER_ASC'],
      [OrderDirection.DESC]: ['INDEX_REFERENCE_NUMBER_DESC'],
    },
  ],

  [
    'fileReference',
    {
      [OrderDirection.ASC]: ['FILE_REFERENCE_ASC'],
      [OrderDirection.DESC]: ['FILE_REFERENCE_DESC'],
    },
  ],
  [
    'indexTransactionDate',
    {
      [OrderDirection.ASC]: ['INDEX_TRANSACTION_DATE_ASC'],
      [OrderDirection.DESC]: ['INDEX_TRANSACTION_DATE_DESC'],
    },
  ],
  [
    '_documentContents',
    {
      [OrderDirection.ASC]: ['_DOCUMENT_CONTENTS_ASC'],
      [OrderDirection.DESC]: ['_DOCUMENT_CONTENTS_DESC'],
    },
  ],
  [
    'indexAmount',
    {
      [OrderDirection.ASC]: ['INDEX_AMOUNT_ASC'],
      [OrderDirection.DESC]: ['INDEX_AMOUNT_DESC'],
    },
  ],
  [
    'usedTotal',
    {
      [OrderDirection.ASC]: [
        'DOCUMENT_APPLIED_AMOUNT_BY_DOCUMENT_FILE_ID__USED_TOTAL_ASC',
      ],
      [OrderDirection.DESC]: [
        'DOCUMENT_APPLIED_AMOUNT_BY_DOCUMENT_FILE_ID__USED_TOTAL_DESC',
      ],
    },
  ],
  [
    'remainingTotal',
    {
      [OrderDirection.ASC]: [
        'DOCUMENT_APPLIED_AMOUNT_BY_DOCUMENT_FILE_ID__REMAINING_TOTAL_ASC',
      ],
      [OrderDirection.DESC]: [
        'DOCUMENT_APPLIED_AMOUNT_BY_DOCUMENT_FILE_ID__REMAINING_TOTAL_DESC',
      ],
    },
  ],
  [
    'isoCode',
    {
      [OrderDirection.ASC]: [
        'COMPANY_CURRENCY_BY_INDEX_CURRENCY_ID__ISO_CODE_ASC',
      ],
      [OrderDirection.DESC]: [
        'COMPANY_CURRENCY_BY_INDEX_CURRENCY_ID__ISO_CODE_DESC',
      ],
    },
  ],
  [
    'comment',
    {
      [OrderDirection.ASC]: ['COMMENT_ASC'],
      [OrderDirection.DESC]: ['COMMENT_DESC'],
    },
  ],
  [
    '_uploadDate',
    {
      [OrderDirection.ASC]: ['_UPLOAD_DATE_ASC'],
      [OrderDirection.DESC]: ['_UPLOAD_DATE_DESC'],
    },
  ],
  [
    '_exportDate',
    {
      [OrderDirection.ASC]: ['_SORT_EXPORT_DATE_ASC'],
      [OrderDirection.DESC]: ['_SORT_EXPORT_DATE_DESC'],
    },
  ],
]);

export const toOrderByVariable = (sort?: SortOrder) => {
  const orderByArray: EntityDocumentsOrderBy[] = [
    '_UPLOAD_DATE_DESC',
    'PRIMARY_KEY_ASC',
  ];
  if (!sort) return orderByArray;

  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return [...(orderBy ? orderBy : []), ...orderByArray];
};

export const toFilterVariable = (
  filterList: FilterArrayType[],
  filterType: string
) =>
  filterList
    .filter((filter) => filter.combineType === FilterCombineType.AND)
    .map((filter) => {
      switch (filter.filterKey) {
        case 'documentTypeId':
          return {
            [filter.filterKey]: {
              equalTo: filter.value,
            },
          };
        case 'indexName':
        case 'indexReferenceNumber':
        case '_documentContents':
        case 'comment':
        case 'fileReference':
          return {
            [filter.filterKey]: {
              [filterType]: filter.value,
            },
          };
        default:
          return undefined;
      }
    });

export const getFiltersFromState = () => {
  const andFilters: FilterArrayType[] = [];
  return { andFilters } as {
    andFilters: FilterArrayType[];
  };
};
